import { Helmet } from 'react-helmet-async';

/**
 * WebSite Schema (JSON-LD)
 * Enables search box and site navigation understanding
 */
const WebSiteSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://cititekpro.com/#website",
    "url": "https://cititekpro.com",
    "name": "CitiTekPro",
    "description": "Custom software development and digital solutions company serving Minnesota businesses",
    "publisher": {
      "@id": "https://cititekpro.com/#organization"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://cititekpro.com/?s={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    },
    "inLanguage": "en-US"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default WebSiteSchema;
